export {};
//# sourceMappingURL=CCSpecificCapabilities.js.map